module.exports = __webpack_public_path__ + "static/media/1.f7df8eb5.png";